// extracted by mini-css-extract-plugin
export default {"textArea":"TextArea_textArea__k4C0U","limiter":"TextArea_limiter__qlX6p","inline":"TextArea_inline__UIrgW","outline":"TextArea_outline__MU2EE"};